module.exports = __webpack_public_path__ + "img/mobile.8a50cc19.gif";